import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService, TextDocument } from '../../shared/dataService';
import { DocumentService } from '../../shared/services/document.service';

@Component({
  selector: 'app-docs-page',
  templateUrl: './docs-page.component.html',
  styleUrls: ['./docs-page.component.scss']
})
export class DocsPageComponent implements OnInit {
  currentRoute: string = '';
  documentId: string | null = null;
  versionId: string | null = null;
  
  // For docs/:id route
  document: TextDocument | null = null;
  isLoading = true;
  isError = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private documentService: DocumentService
  ) {}

  ngOnInit(): void {
    // Determine which route we're on based on URL structure
    this.documentId = this.route.snapshot.paramMap.get('id');
    this.versionId = this.route.snapshot.paramMap.get('versionId');
    
    const urlSegments = this.route.snapshot.url.map(segment => segment.path);
    
    if (urlSegments.includes('compare')) {
      this.currentRoute = 'compare';
    } else if (this.versionId) {
      this.currentRoute = 'version';
    } else if (urlSegments.includes('versions')) {
      this.currentRoute = 'versions';
    } else {
      this.currentRoute = 'document';
      this.fetchLatestDocument();
    }
  }

  private fetchLatestDocument(): void {
    if (!this.documentId) {
      this.isError = true;
      this.isLoading = false;
      return;
    }

    this.documentService.getLatestDocumentVersion(this.documentId).subscribe({
      next: (result) => {
        this.document = result.document;
        this.isLoading = result.isLoading;
        this.isError = result.isError;
      },
      error: (error) => {
        console.error('Error fetching latest document version:', error);
        this.isError = true;
        this.isLoading = false;
      }
    });
  }
}
